import * as React from 'react'

import * as Style from './style.css'

export interface IProps
  extends Omit<React.ComponentPropsWithoutRef<'input'>, 'type' | 'className'> {
  thumbnailUrl?: string
  setThumbnail: (thumbnailUrl: string) => void
}

export const InputImage = React.forwardRef<HTMLInputElement, IProps>(
  ({ thumbnailUrl, setThumbnail, ...props }, ref) => {
    const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!e.target.files) return

      const fileObject = e.target.files[0]

      //画像でない場合は処理終了
      if (fileObject.type.indexOf('image') < 0) {
        window.alert('画像ファイルを指定してください。')
        return false
      }
      setThumbnail(window.URL.createObjectURL(fileObject))
    }

    return (
      <div className={Style.InputImage}>
        {!!thumbnailUrl && <img src={thumbnailUrl} />}
        {!thumbnailUrl && <img src="/img/no_photo.png" />}
        <div className={Style.InputImageCtrl}>
          <input
            type="file"
            {...props}
            onChange={(event) => {
              changeHandler(event)
              props.onChange && props.onChange(event)
            }}
            ref={ref}
          />
        </div>
      </div>
    )
  },
)
